<template>
  <tr>
    <td :colspan="colspan ?? 1">
      <p class="text-center text-body-1 py-10">No records found.</p>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'NoRecordsFound',
  props: ['colspan'],
};
</script>
